<div class="bulk-btn">
  <button (click)="openSheet($event)" mat-button>Continue</button>
</div>

<ng-template #bulkDonation>
  <div class="wrap-bulk">
    <div class="header">
      <div class="maintitle">Contribute as much as you can</div>
      <div class="subtitle">Fundraisers that couldn’t raise money</div>
    </div>
    <div class="divideline"></div>
    <div class="storytiles" *ngFor="let item of campaigns">
      <div class="tile">
        <div class="tileinfo">
          <div class="timeleft">
            <em class="material-icons">schedule</em>
            <span>{{(item?.end_date | dayjs:'diffInDays') + ((item?.end_date | dayjs:'diffInDays') > 1 ? ' Days ' : ' Day ') }} {{item?.end_date | difftime}} hours left</span>
          </div>
          <div class="storytitle">{{item?.title}}</div>
          <div class="moneyshort"  *ngIf="item?.amount_remaining"><strong><app-currency-icon *ngIf="currency" [currency]="currency"></app-currency-icon> {{item?.amount_remaining | inrFormat}}</strong> remaining</div>
          <div class="progress">
            <app-progress-bar [amount]="item?.raised?.raised" [goal]="item?.amount_requested"></app-progress-bar>
          </div>
        </div>
        <div class="tileimg">
          <img loading="lazy" [attr.data-src]="item?.story_widget?.cdn_path || item?.widget?.cdn_path" [default]="util.defaultImg" alt="">
          <div class="dntbtn">
            <button *ngIf="!selected.includes(item.id)" class="btn" (click)="val = hide(item.id)">
              <em class="material-icons">add</em>
              Contribute
            </button>
          </div>
          <div class="incrementbtn" *ngIf="selected.includes(item.id)">
            <button class="plus" (click)="amtchanger('minus', item.id)" mat-ripple>
              <em class="material-icons">remove</em>
            </button>
            <div><app-currency-icon *ngIf="currency" [currency]="currency"></app-currency-icon>{{bulkData[item.id].amount}}</div>
            <button class="minus" (click)="amtchanger('plus', item.id)" [ngClass]="{'max': bulkData[item.id].amount === minamount[currency].minamt * 20}" mat-ripple>
              <em class="material-icons">add</em>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="submitbtn" [ngClass]="{'active': isAnySelected}">
      <button (click)="submit()" mat-button [disabled]="isOrderLoading ? true : false">
        <span *ngIf="!isOrderLoading">{{btnlabel}}</span>
        <div *ngIf="isOrderLoading" class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
      </button>
    </div>
  </div>
</ng-template>

<ng-template #bulkDonationHf>
  <div class="wrap-bulk-hf">
    <div class="header">
      <div class="sub-title">Contribute as much as you can..</div>
      <div class="title">Towards their health and yours!</div>
    </div>
    <div class="options">
      <div class="donation-cards">
        <div *ngFor="let item of campaigns" class="card">
          <div class="left">
            <div class="timer">
              <em class="material-icons">schedule</em>
              <span>{{(item?.end_date | dayjs:'diffInDays') + (item?.end_date | dayjs:'diffInDays') > 1 ? ' Days ' : ' Day ' }} {{item?.end_date | difftime}} hours left</span>
            </div>
            <div class="title" [innerHTML]="item?.title"></div>
            <div class="bottom">
              <div *ngIf="item?.amount_remaining" class="remaining">
                <strong><app-currency-icon *ngIf="currency" [currency]="currency"></app-currency-icon> {{item?.amount_remaining | inrFormat}}</strong> remaining
              </div>
              <div class="progress">
                <app-progress-bar [amount]="item?.raised?.raised" [goal]="item?.amount_requested"></app-progress-bar>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="image"><img loading="lazy" [attr.data-src]="item?.story_widget?.cdn_path || item?.widget?.cdn_path" alt="story" [default]="util.defaultImg" /></div>
            <div class="btn">
              <button *ngIf="!selected.includes(item.id)" (click)="hide(item.id)" mat-ripple><em class="material-icons">add</em> Contribute</button>
            </div>
            <div class="increment-btn" *ngIf="selected.includes(item.id)">
              <button class="plus" (click)="amtchanger('minus', item.id)" mat-ripple>
                <em class="material-icons">remove</em>
              </button>
              <div class="amount"><app-currency-icon *ngIf="currency" [currency]="currency"></app-currency-icon>{{bulkData[item.id].amount}}</div>
              <button class="minus" (click)="amtchanger('plus', item.id)" [ngClass]="{'max': bulkData[item.id].amount === minamount[currency].minamt * 20}" mat-ripple>
                <em class="material-icons">add</em>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="hf-card">
        <div class="shadow1"><img src="/assets/images/health-first/shadow-1.png" alt=""></div>
        <div class="shadow2"><img src="/assets/images/health-first/shadow-2.png" alt=""></div>
        <div class="off-tag">85% OFF</div>
        <div class="hf-content">
          <div class="limited"><img src="/assets/images/health-first/fire.png" alt=""> <span>Limited Time Deal</span></div>
          <div class="text">
            <div class="title">Try India's best <span>budget-friendly</span> family health plan</div>
            <div class="desc">Unlimited FREE doctor consultations plus up to 70% off on lab tests and medicines</div>
          </div>
        </div>
        <div class="bottom-act">
          <div class="logo"><img src="/assets/images/hf-mini-logo-dark.png" alt=""></div>
          <div class="add-btn">
            <button type="button" [ngClass]="{'added': hfAdded}" (click)="addPlan()" mat-ripple><em class="material-icons">{{hfAdded ? 'remove' : 'add'}}</em> <div>{{hfAdded ? 'REMOVE' : ('Add @₹' + vars.hfMiniPlans.amount)}} <span *ngIf="!hfAdded" class="strike"> ₹999</span></div></button>
          </div>
        </div>
      </div>
    </div>
    <div class="submitbtn" [ngClass]="{'active': isAnySelected}">
      <button (click)="submit()" mat-button [disabled]="isOrderLoading ? true : false">
        <span *ngIf="!isOrderLoading">{{btnlabel}}</span>
        <div *ngIf="isOrderLoading" class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
      </button>
    </div>
  </div>
</ng-template>